import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'ethnic-background-questiontype',
  templateUrl: './ethnic.background.component.html'
})
export class EthnicBackgroundComponent implements OnInit, OnDestroy {
  @Input() required:boolean;
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() disabled:boolean;
  formError:false;
  value:'';
  formSegment:FormGroup;

  public getValue():object {
    var result={};
    if(!this.disabled) {
      result[this.questionid]=this.formSegment.value;
    } else {
      result[this.questionid]=null;
    }
    return result;
  }

  isValid():boolean {
    if(this.required) {
      return (
        this.formSegment.controls['horl'].value
        || this.formSegment.controls['neitherhnorl'].value
        || this.formSegment.controls['decline'].value
      );
    }
    return true;
  }
  validate():boolean {
    this.formSegment.controls['horl'].markAsTouched();
    this.formSegment.controls['neitherhnorl'].markAsTouched();
    this.formSegment.controls['decline'].markAsTouched();
    return this.isValid();
  }

  get touched():boolean {
    return (
      this.formSegment.controls['horl'].dirty
      || this.formSegment.controls['neitherhnorl'].dirty
      || this.formSegment.controls['decline'].dirty
      || this.formSegment.controls['horl'].touched
      || this.formSegment.controls['neitherhnorl'].touched
      || this.formSegment.controls['decline'].touched
    );
  }

  ngOnInit() {
    var i,init={};
    init['horl']=new FormControl();
    init['neitherhnorl']=new FormControl();
    init['decline']=new FormControl();

    this.formSegment=new FormGroup(init);

    if(((typeof this.value)==='object') && (this.value !== null)) {
      for(i in init) {
        if(this.value.hasOwnProperty(i)) {
          init[i].setValue(this.value[i]);
        }
      }
    }
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/ethnic.background.component.ts